export const PAYMENT_TYPE = {
  SUBSCRIPTION: 'subscription',
  RENT: 'rent',
  PURCHASE: 'sale',
  MEMBER_ONLY: 'memberOnly',
};

export const PAYMENT_PERMS = {
  [PAYMENT_TYPE.SUBSCRIPTION]: ['unlimitedStreaming', 'instantAccess', 'monthlyPayment'],
  [PAYMENT_TYPE.PURCHASE]: ['singleVideo', 'onePayment', 'unlimitedStreaming'],
  [PAYMENT_TYPE.RENT]: ['singleVideoStreaming', 'streamingPeriod'],
  [PAYMENT_TYPE.MEMBER_ONLY]: ['singleVideo', 'unlimitedStreaming'],
};

export const PAYMENT_PROVIDER = {
  PAYPAL: 'PayPal',
  CASHIER: 'Cashier',
};

export const PAYMENT_PROVIDER_ID = {
  STRIPE: 'com.stripe',
  PAYPAL: 'payPal',
};

export const RECURRING_PAYMENT_PROVIDER_IDS = [
  PAYMENT_PROVIDER_ID.STRIPE,
  PAYMENT_PROVIDER_ID.PAYPAL,
];

export const CHARGE_INTENT = {
  SALE: 'SALE',
  RECURRING: 'RECURRING',
};

export const CHARGE_INTENT_BY_TYPE = {
  [PAYMENT_TYPE.SUBSCRIPTION]: CHARGE_INTENT.RECURRING,
  [PAYMENT_TYPE.PURCHASE]: CHARGE_INTENT.SALE,
  [PAYMENT_TYPE.RENT]: CHARGE_INTENT.SALE,
  [PAYMENT_TYPE.MEMBER_ONLY]: null,
};



// WEBPACK FOOTER //
// ./src/shared/constants/payments.js